import { PAYMENTS_API_URL } from 'data/constants';
import { DepositStatus } from 'data/payments/models';

export async function setPaymentStatus(
  depositId: string,
  status: DepositStatus,
) {
  const result = await fetch(
    `${PAYMENTS_API_URL}/public/payments/${depositId}/test/status`,
    {
      method: 'POST',
      body: JSON.stringify({ status }),
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  if (result.status > 399) {
    const responseBody = await result.text();
    throw new Error(`Failed to set payment name: ${responseBody}`);
  }
}
